import {ReactNode} from 'react';
import {isFabricWebview} from '~/common/utils/webview';
import {Payload} from '~/ViewInvitation/common/RSVPModalVariantAB/types';
import {isInRsvpSuccessAffilRoktControl} from './experiments';
import {RSVPModal} from './RSVPModal';
import {RSVPModalVariantAB} from './RSVPModalVariantAB/RSVPModalVariantAB';

type Status = 'Yes' | 'Maybe' | 'No';

export type RSVPModalProps = {
  status: Status;
  onClose: () => void;
  open: boolean;
  onSubmitRSVP: (payload: Payload, doNotClose?: boolean) => Promise<void>;
};

export const RSVPModalTestAB = ({
  status = 'No',
  onClose,
  open,
  onSubmitRSVP,
}: RSVPModalProps): ReactNode => {
  const isWebview = isFabricWebview();

  const inControl = isInRsvpSuccessAffilRoktControl({readOnly: !open || isWebview});

  if (!open) {
    return null;
  }

  if (inControl || isWebview) {
    return (
      <>
        {open && <div className="active-overlay-bg" />}
        <RSVPModal status={status} onClose={onClose} open={open} onSubmitRSVP={onSubmitRSVP} />
      </>
    );
  }

  return (
    <RSVPModalVariantAB status={status} onClose={onClose} open={open} onSubmitRSVP={onSubmitRSVP} />
  );
};
